import { Box } from "@mui/material";
import ColorUtil from "@plannel/pages/utils/color-util";
import { FS } from "@plannel/utils/font-util";

/*
 * 공용 ABC-XYZ 등급 배지 — Plannel 틴트 칩(ColorUtil.tintAbcXyzChipSx).
 * 은은한 배경 + 같은 hue 의 진한 글자·테두리(밝은 ABC 팔레트라 darken 으로 대비 확보).
 *
 * 사용:
 *   · AG-Grid 일반 셀 : columnDef `cellRenderer: AbcXyzChip` (셀 값 = 등급코드). 자체 중앙정렬.
 *   · AG-Grid 그룹 셀 : `cellRenderer: 'agGroupCellRenderer'` + `cellRendererParams.innerRenderer: AbcXyzChipInline`
 *                       (펼침 화살표 옆에 인라인 칩 — 전체높이 래퍼 없이).
 *   · 일반 JSX       : <AbcXyzChip value="AX" />
 * 값이 ABC-XYZ 등급코드가 아니면 그대로 텍스트만 표시.
 */

// 알약(pill) 본체.
// ★ 고정 height 금지 — 조밀한 그리드 행(≈22px)에서 칩이 행을 꽉 채워 하단 격자선과 겹친다.
//   높이는 fontSize×lineHeight + 상하 패딩으로 콘텐츠 기반(≈16px)으로 두고, 셀의 세로 중앙정렬에 맡긴다.
const Pill = ({ code, sx }) => (
  <Box component="span" sx={{
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    minWidth: 30, px: 0.75, py: "1px", borderRadius: 999,
    fontSize: FS.BODY, fontWeight: 700, lineHeight: 1.3, verticalAlign: "middle", flexShrink: 0, ...sx,
  }}>
    {code}
  </Box>
);

const AbcXyzChip = ({ value, inline = false }) => {
  // 값 정규화: 리치셀렉트 편집 컬럼 등은 값이 객체({name:"AX"})일 수 있어 name/value/code 를 추출.
  // 등급코드는 관례상 대문자(AX…CZ) — 소문자로 저장된 필드(예: DP grade)도 대문자화.
  const raw = value == null ? "" : (typeof value === "object" ? (value.name ?? value.value ?? value.code ?? "") : value);
  const code = raw === "" ? "" : String(raw).trim().toUpperCase();
  const sx = ColorUtil.tintAbcXyzChipSx(code);
  if (!sx) {
    return code;
  }
  // inline: 그룹 셀 innerRenderer 용 — 화살표 옆에 인라인 배치(전체높이 래퍼 없음)
  if (inline) {
    return <Pill code={code} sx={sx} />;
  }
  // 기본: 일반 셀 — 셀 안에서 세로 중앙정렬
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
      <Pill code={code} sx={sx} />
    </Box>
  );
};

// 그룹 셀(agGroupCellRenderer) innerRenderer 용 인라인 변형.
export const AbcXyzChipInline = (props) => <AbcXyzChip {...props} inline />;

export default AbcXyzChip;
